<template>
    <div class="expander-text">
        <div role="button" class="expander-header">
            <div class="is-flex">
                <div class="ml-4 is-flex-grow-1">
                    <b-field label="Title" label-position="inside">
                        <b-input v-model="working.title" expanded @blur="save"/>
                    </b-field>
                </div>
                <div class="pt-1 pl-5 pr-2">
                    <i class="fal fa-dash"></i>
                </div>
            </div>
        </div>

        <div class="expander-content content">
            <editor-js
                :data="working.content"
                @save="save"
            />
        </div>
    </div>
</template>

<script>
    import EditorJs from "../EditorJs.vue";

    export default {
        components: {EditorJs},
        props: ['data'],
        data: function() {
            return {
                working: null
            }
        },
        methods: {
            save(data) {
                this.working.content = data;
                this.$emit('save', JSON.parse(JSON.stringify(this.working)));
            }
        },
        created() {
            if (!this.data.title) {
                this.working = {title: '', content: null, attributes: {}};
            } else {
                this.working = {...this.data};
            }
        }
    };
</script>

<style scoped lang="scss">
    .expander-text {
        border-left: 3px solid #336699;
        padding-bottom: 10px;
        border-radius: 6px;

        .expander-header {
            padding: 10px;

            i.fa-dash {
                padding-top: 10px;
                font-size: 20px;
            }
        }
    }
</style>
